import { useEffect, useCallback, useRef } from "react";
import { useDispatch } from "react-redux";
import { db } from "helpers/firebase/firebaseConfig";
import Cookies from "js-cookie";
import { fetchOrdersRequest } from "../../store/orderManagement/actions";
import { fetchServicesRequest } from "../../store/servicesManagment/actions";
import { fetchTransactions } from "../../store/dbInvoices/actions";
import { fetchNotificationsRequest } from "store/actions";
import { batch } from "react-redux";
import { throttle } from 'lodash';
import { onSnapshot, collection, query, where } from "firebase/firestore";
import { ImportExport } from "aws-sdk";

const OrderSubscription = ({ children }) => {
  const providerId = Cookies.get("usersessionId", {
    secure: true,
    sameSite: 'strict',
    path: "/"
  });
  const dispatch = useDispatch();

      // Audio reference
  const audioRef = useRef(null);

  const refreshData = useCallback(throttle(() => {
    batch(() => {
      dispatch(fetchOrdersRequest());
      dispatch(fetchNotificationsRequest());
    });
  }, 1000), [dispatch, providerId]);

  useEffect(() => {
    if (!providerId) return;

            // Prepare audio element
    audioRef.current = new Audio("/notification.mp3");

    // Create a query for this provider's orders
    const ordersQuery = query(
      collection(db, "Booking"),
      where("service_providers_id", "==", providerId)
    );

    // Set up real-time listener
    const unsubscribe = onSnapshot(ordersQuery, 
      (snapshot) => {
        // Only refresh if there are actual changes
        if (!snapshot.metadata.hasPendingWrites) {
          refreshData();
          audioRef.current?.play().catch(err => console.error("Audio play failed:", err));
        }
      },
      (error) => {
        console.error("Error listening to orders:", error);
      }
    );
    const unsubscribeService = onSnapshot(
      collection(db, "service_provider_services"),
      (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
               dispatch(fetchServicesRequest());
          } else if (change.type === "modified") {
            dispatch(fetchServicesRequest());
          }
        });
      },
      (error) => {
        console.error("Services subscription error:", error);
      }
    );

    const unsubscribeInvoices = onSnapshot(
      collection(db, "service_provider_sale_invoices"),
      (snapshot) => { 
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
               dispatch(fetchTransactions());
          } else if (change.type === "modified") {
            dispatch(fetchTransactions());
          }
        });
      },
      (error) => {
        console.error("Invoices subscription error:", error);
      }
    );



    return () => {
      unsubscribe();
      unsubscribeService();
      unsubscribeInvoices();
    };
  }, [providerId, refreshData]);

  return children;
};

export default OrderSubscription;